import { Controller } from "@hotwired/stimulus"
import IMask from "imask"
// Connects to data-controller="form--height"
export default class extends Controller {
  static targets = ["inputUs", "inputEu"]

  connect() {
    IMask(this.inputUsTarget, {
      mask: "0'00\"",
    })
    IMask(this.inputEuTarget, {
      mask: "000",
    })
  }

  updateHeightUs() {
    this.inputUsTarget.value = this.toFeet(parseInt(this.inputEuTarget.value))
  }

  updateHeightEu() {
    this.inputEuTarget.value = this.toCm(this.inputUsTarget.value)
  }

  toFeet(n) {
    var realFeet = (n * 0.3937) / 12
    var feet = Math.floor(realFeet)
    var inches = Math.round((realFeet - feet) * 12)
    if (inches && feet) {
      return feet + "'" + inches + '"'
    } else if (feet) {
      return feet + "'"
    } else {
      return ""
    }
  }

  toCm(str) {
    var feet = parseInt(str.split("'")[0])
    var inches = parseInt(str.split("'")[1])
    if (isNaN(inches)) {
      inches = 0
    }
    if (feet) {
      return Math.round(feet * 30.48 + inches * 2.54)
    } else {
      return ""
    }
  }
}
